import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

import { TAB_PARAM_KEYS } from "@/constants/TabKeys";
import { getModelLink } from "@/modules/model";

export const useIsFormEnginePreviewMode = () => {
  const { t } = useTranslation();
  const { search, pathname } = useLocation();
  const previewTab = t("form:preview").toLowerCase();
  const currentTab = new URLSearchParams(search ?? {}).get(
    TAB_PARAM_KEYS.CONTEXT_TAB_KEY
  );
  const isPreviewTab = !currentTab || currentTab.toLowerCase() === previewTab;
  const isAssetTypesPath = pathname?.startsWith(getModelLink("assettype"));
  const isInterventionTemplatesPath = pathname?.startsWith(
    getModelLink("interventiontemplate")
  );

  const isPreviewMode =
    (isAssetTypesPath || isInterventionTemplatesPath) && isPreviewTab;

  return !!isPreviewMode;
};
